
import GenreMaker from '../anychart/genreMaker'; 

var LineChart = class LineChart extends GenreMaker {

  isSpline(){
    return this.subGenre.includes("spline");
  }

  setData(state){
        super.setData(state);
        var subGenre = this.getSubGenre(state);
        // if(this.ifSeries()){
            for (var series in this.data) {
                if(this.isBasic()){
                    this.chart.line(this.data[series]);
                }else if(this.ifIncluded("spline")){
                    this.chart.spline(this.data[series]);
                }
            }
        // }else{
              
        //     if(subGenre=="line"){
        //         this.chart.line(this.data);
        //     }else if(subGenre=="spline"){
        //         this.chart.spline(this.data);
        //     }
        // }
    }
    
    createChart(subGenre){
        var chart = anychart.line();
        return chart;
    } 
}


    
GenreMaker.line = LineChart;

export var LineChart;


// WEBPACK FOOTER //
// ./src/anychart/lineChart.js